<p>equipment-show works!</p>
